import { Injectable } from '@angular/core';
import { UserActionTrackerProxy } from '../../proxy/user-action-tracker/user-action-tracker.proxy';

@Injectable()
export class UserActionTrackerService {

  constructor(private proxy: UserActionTrackerProxy) { }

  account_requestcancel_supportemail(){
    return this.proxy.account_requestcancel_supportemail();
  }
}
